import TabeeAuth from './tabee-auth'
import LoginForm from './dist/components/LoginForm'
import SignUpForm from './dist/components/SignUpForm'

export {
    LoginForm,
    SignUpForm
}

export default TabeeAuth